module.exports = __webpack_public_path__ + "img/cunyanglogo.7d135463.jpg";